<template>
  <div v-if="profile" class="row container--stretch m-n">
    <div class="col-lg-2 col-md-2 col-sm-3 hidden-xs no-padder left bg-grey">
      <div class="container-fluid container-fluid-padding">
        <div class="item">
          <contact></contact>
        </div>
        <div class="item">
          <social-media></social-media>
        </div>
        <div class="item">
          <business-hours></business-hours>
        </div>
        <div class="item">
          <affiliates></affiliates>
        </div>
        <div class="item">
          <related-companies :profile_id="profile.profile_id"></related-companies>
        </div>
      </div>
    </div>
    <div class="col-lg-10 col-md-10 col-sm-9 no-padder">
      <div class="container-fluid container--padding" v-if="profile">
        <div class="about-page-head">
          <h1 class="m-n text-center text-u-c title-about">About</h1>
        </div>
        <hr class="padding-mobile" style="width: 100%; margin-top: 0; margin-bottom: 0;" />
        <div
          v-if="!profile.about && !profile.corporateProfile.history_and_milestones && !profile.corporateProfile.awards && !profile.corporateProfile.products_and_services && !profile.geolocation"
          class="text-center text-muted"
          style="margin-top: 50px;font-style: italic; text-transform: lowercase;"
        >no items found</div>
        <div v-else>
          <div class="item">
            <snapshot></snapshot>
          </div>
          <div class="products-services margin-top padding-mobile" v-if="profile.about">
            <div class="page-header m-n p-n">
              <h1 class="m-n text-center text-u-c title-font">Description</h1>
            </div>
            <div class="text-lg dec-font m-t-md">{{ profile.about }}</div>
          </div>
          <div
            class="products-services margin-top padding-mobile"
            v-if="profile.corporateProfile.history_and_milestones"
          >
            <div class="page-header m-n p-n">
              <h1 class="m-n text-center text-u-c title-font">History & Milestones</h1>
            </div>
            <div
              class="text-lg dec-font m-t-md"
              v-html="profile.corporateProfile.history_and_milestones"
            ></div>
          </div>
          <div
            class="products-services margin-top padding-mobile"
            v-if="profile.corporateProfile.awards && profile.corporateProfile.awards.length"
          >
            <div class="page-header m-n p-n">
              <h1 class="m-n text-center text-u-c title-font">Awards</h1>
            </div>
            <div class="text-lg dec-font m-t-md">
              <div class="m-b-md text-center" v-for="(award, index) in profile.corporateProfile.awards" :key="index">
                <span class="block">
                  <span class="fontColor">{{ award.name }}</span>
                  <span>{{ award.organization }}</span>
                  <small class="text-muted">{{ moment(award.date).format('MMM YYYY') }}</small>
                </span>
                <span class="clear">{{ award.description}}</span>
              </div>
            </div>
          </div>
          <div
            class="products-services margin-top padding-mobile"
            v-if="profile.corporateProfile.products_and_services"
          >
            <div class="page-header m-n p-n">
              <h1 class="m-n text-center text-u-c title-font">Products & Services</h1>
            </div>
            <div
              class="text-lg dec-font m-t-md"
              v-html="profile.corporateProfile.products_and_services"
            ></div>
          </div>

          <div v-if="profile.geolocation" class="google-maps xs-item hidden-xs margin-top">
            <div class="page-header m-n p-n">
              <h1 class="m-n text-center text-u-c title-font">Location map</h1>
            </div>
            <google-map :location="profile.geolocation" @get-marker="setLocation"></google-map>
          </div>
        </div>

        <div
          class="products-services margin-top padding-mobile"
          v-if="profile.corporateProfile.employer_why_join_us"
        >
          <div class="page-header m-n p-n">
            <h1 class="m-n text-center text-u-c title-font">Why join us</h1>
          </div>
          <div
            class="text-lg dec-font m-t-md"
            v-html="profile.corporateProfile.employer_why_join_us"
          ></div>
        </div>

        <div
          class="products-services margin-top padding-mobile"
          v-if="profile.corporateProfile.employer_values"
        >
          <div class="page-header m-n p-n">
            <h1 class="m-n text-center text-u-c title-font">Our work values</h1>
          </div>
          <div class="text-lg dec-font m-t-md" v-html="profile.corporateProfile.employer_values"></div>
        </div>

        <div
          class="products-services margin-top padding-mobile"
          v-if="profile.corporateProfile.employer_environment"
        >
          <div class="page-header m-n p-n">
            <h1 class="m-n text-center text-u-c title-font">Our work environment</h1>
          </div>
          <div
            class="text-lg dec-font m-t-md"
            v-html="profile.corporateProfile.employer_environment"
          ></div>
        </div>

        <div
          class="products-services margin-top padding-mobile"
          v-if="profile.corporateProfile.employer_benefits"
        >
          <div class="page-header m-n p-n">
            <h1 class="m-n text-center text-u-c title-font">Benefits</h1>
          </div>
          <div class="text-lg dec-font m-t-md" v-html="profile.corporateProfile.employer_benefits"></div>
        </div>

        <div
          class="products-services margin-top padding-mobile"
          v-if="profile.corporateProfile.employer_dress_code"
        >
          <div class="page-header m-n p-n">
            <h1 class="m-n text-center text-u-c title-font">Dress code</h1>
          </div>
          <div
            class="text-lg dec-font m-t-md"
            v-html="profile.corporateProfile.employer_dress_code"
          ></div>
        </div>

        <div v-if="profile.geolocation" class="small_screen hidden-sm hidden-md hidden-lg">
          <div class="google-maps margin-top">
            <div class="page-header m-n p-n">
              <h2 class="text-center m-t-0 m-b-md">
                <small class="text-u-c title-font">Location map</small>
              </h2>
            </div>
            <google-map :location="profile.geolocation" @get-marker="setLocation"></google-map>
          </div>
          <div class="contact xs-item">
            <contact></contact>
          </div>
          <div class="social-media xs-item">
            <social-media></social-media>
          </div>
          <div class="business-hours xs-item">
            <business-hours></business-hours>
          </div>
          <div class="affiliates xs-item">
            <affiliates></affiliates>
          </div>
          <div class="affiliates xs-item">
            <related-companies></related-companies>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-3 hidden-lg hidden-md hidden-sm hidden-xs right">
      <div class="container-fluid p-y">
        <div class="xs-item">
          <snapshot></snapshot>
        </div>
        <div class="xs-item">
          <business-hours></business-hours>
        </div>
        <div class="xs-item">
          <affiliates></affiliates>
        </div>
        <div class="xs-item hidden-lg">
          <related-companies :profile_id="profile.profile_id"></related-companies>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import snapshot from "../../components/about/snapshot";
import businessHours from "../../components/left-side/business-hours";
import GoogleMap from "../../components/about/google-map";
import contact from "../../components/left-side/contact";
import affiliates from "../../components/left-side/affiliations";
import relatedCompanies from "../../components/left-side/related-companies";
import team from "../../components/left-side/team";
import userNav from "../../components/header/navbar";
import socialMedia from "../../components/left-side/social_media";
import { mapGetters } from "vuex";
import moment from "moment";

export default {
  components: {
    snapshot,
    businessHours,
    GoogleMap,
    socialMedia,
    contact,
    affiliates,
    relatedCompanies,
    team,
    userNav
  },
  props: {
    profile: null
  },
  data() {
    return {
      moment: moment
    };
  },
  methods: {
    setLocation(marker) {}
  },
  computed: {
    ...mapGetters(["types", "industries"])
  },
  watch: {
    profile: function(to) {
      this.profile = to;
    }
  }
};
</script>

<style lang="scss" scoped>
@media only screen and (min-width: 1200px) {
  .container-fluid-padding {
    padding-left: 20px;
    padding-right: 30px;
  }
  .container--padding {
    padding-left: 180px !important;
    padding-right: 230px !important;
    padding-bottom: 50px;
  }
  .left .item {
    margin-top: 0px;
  }
  .about-page-head {
    padding-top: 30px;
    padding-bottom: 20px;
  }
  .title-about {
    font-weight: 300;
    font-size: 24px;
    line-height: 28px;
    text-align: center;
    letter-spacing: 0.72px;
    color: #000;
  }
  .title-font {
    font-weight: 300;
    font-size: 26px;
    line-height: 28px;
    color: #000;
  }
  .dec-font {
    font-weight: normal;
    font-size: 16px;
    line-height: 19px;
    text-align: justify;
    -moz-text-align-last: center;
    text-align-last: center;
    color: #555555;
  }
  .p-n {
    padding: 0px;
  }
  .fontColor {
    color: #000;
  }
  .container--padding hr {
    border-color: #ddd;
  }
  .margin-top {
    margin-top: 80px;
  }
}
@media only screen and (max-width: 1199px) and (min-width: 1024px) {
  .container--padding {
    padding-left: 90px;
    padding-right: 100px;
    padding-bottom: 50px;
  }
}
@media only screen and (max-width: 1023px) and (min-width: 768px) {
  .container--padding {
    padding-left: 30px;
    padding-right: 40px;
    padding-bottom: 50px;
  }
}
@media only screen and (max-width: 1199px) and (min-width: 768px) {
  .container-fluid-padding {
    padding-left: 15px;
    padding-right: 15px;
  }
  .left .item {
    margin-top: 0px;
  }
  .about-page-head {
    padding-top: 30px;
    padding-bottom: 20px;
  }
  .title-about {
    font-weight: 300;
    font-size: 20px;
    line-height: 23px;
    text-align: center;
    letter-spacing: 0.72px;
    color: #000;
  }
  .title-font {
    font-weight: 300;
    font-size: 26px;
    line-height: 28px;
    color: #000000;
  }
  .dec-font {
    font-size: 16px;
    line-height: 19px;
    text-align: justify;
    -moz-text-align-last: center;
    text-align-last: center;
    color: #555555;
  }
  .p-n {
    padding: 0px;
  }
  .fontColor {
    color: #000;
  }
  .container--padding hr {
    border-color: #ddd;
  }
  .margin-top {
    margin-top: 70px;
  }
}
@media only screen and (max-width: 767px) {
  .container--padding {
    padding-left: 0px;
    padding-right: 0px;
  }
  .padding-mobile {
    padding-left: 30px;
    padding-right: 30px;
  }
  .small_screen {
    background-color: #f1f1f1;
  }
  .google-maps {
    background-color: #fff;
  }
  .about-page-head {
    padding-top: 30px;
    padding-bottom: 10px;
  }
  .title-about {
    font-weight: 300;
    font-size: 20px;
    line-height: 23px;
    text-align: center;
    letter-spacing: 0.72px;
    color: #000;
  }
  .title-font {
    font-weight: 300;
    font-size: 26px;
    line-height: 26px;
    color: #000000;
  }
  .dec-font {
    font-size: 16px;
    line-height: 16px;
    text-align: justify;
    -moz-text-align-last: center;
    text-align-last: center;
    color: #555555;
  }
  .p-n {
    padding: 0px;
  }
  .fontColor {
    color: #000;
  }
  .container--padding hr {
    border-color: #ddd;
  }
  .margin-top {
    margin-top: 70px;
  }
  .xs-item {
    margin-bottom: 40px;
  }
}

// @media only screen and (max-width: 600px) and (min-width: 400px)  {...}
</style>
